<script setup lang="ts">
import EmptyBoxIcon from "@/components/icons/navBarIcons/EmptyBoxIcon.vue";

defineProps<{ message?: string, description?: string }>()

</script>

<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-px-6 tw-py-10">
    <div
      class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100 dark:tw-bg-gray-800 tw-w-24 tw-h-24 tw-text-gray-400 dark:tw-text-gray-500">
      <EmptyBoxIcon width="50px" height="50px"/>
    </div>
    <p v-if="message" class="tw-mt-4 tw-text-base tw-font-medium tw-text-gray-700 dark:tw-text-gray-100" v-text="message"/>
    <p v-if="description"
       class="tw-mt-1 tw-text-sm tw-leading-relaxed tw-text-gray-500 dark:tw-text-gray-400 tw-max-w-[260px]" v-text="description"/>
  </div>
</template>
